import {createRouter, createWebHistory,} from 'vue-router'
import store from '@/store';
import LayoutPage from "@/layout/layoutPage/index";
import {getAction} from "@/utils/http/service";
import {ls} from "@/utils/util"
import {sys_menu} from "@/api/adminService";
// import axios from "axios";
// const {publicPath} = require("../../web.config");

let routerList = [];
const importAllRoute = (list) => {
    console.log(list,12);
    list.keys().forEach(item => {
        routerList.push(...list(item).default);
    })
}
importAllRoute(require.context('./module/', true, /\.router\.js/));

const routes = [
    {
        path: '/',
        redirect: '/index'
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('@/views/login'),
        meta: {title: "登录"}
    },
    {
        path: '/register',
        name: 'register',
        component: () => import('@/views/register'),
        meta: {title: "注册"}
    },
    {
        path: '/forgetPass',
        name: 'forgetPass',
        component: () => import('@/views/registerChild/forgetPass'),
        meta: {title: "修改密码"}
    },
    
    {
        path: '/hotMap',
        name: 'hotMap',
        component: () => import('@/views/registerChild/hotMap'),
        meta: {title: "科创地图"}
    },
    {
        path: '/registerStatus',
        name: 'registerStatus',
        component: () => import('@/views/registerChild/registerStatus'),
        meta: {title: "查询注册审核状态"}
    },
    {
        path: "/demo",
        component: LayoutPage,
        redirect: "/demo/error",
        children: [
            {
                path: '/demo/error',
                name: 'demo-error',
                component: () => import('@/views/demo/error'),
                meta: {title: "菜单不能切换问题复现和解决", requireLogin: true}
            },
            {
                path: '/demo/form',
                name: 'demo-form',
                component: () => import('@/views/demo/form'),
                meta: {title: "解决表单中文件上传还提示的问题", requireLogin: false}
            },
        ]
    },
    {
        path: "/main",
        component: LayoutPage,
        redirect: "/index",
        children: [
            ...routerList,
            {
                path: '/e-403',
                name: 'e-403',
                component: () => import('@/views/error/403'),
                meta: {title: "403", requireLogin: false}
            },
        ]
    },
    {
        path: '/404',
        name: '404',
        component: () => import('@/views/error/404'),
        meta: {title: "404"}
    },
    {
        path: '/403',
        name: '403',
        component: () => import('@/views/error/403'),
        meta: {title: "403"}
    },
    {
        path: "/:catchAll(.*)",
        redirect: "/404"
    },
]

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    // history: createWebHashHistory(),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition
        } else {
            return {top: 0}
        }
    }
});

function checkAuthRouter(to, next) {
    // if (store.getters.authRouterList.includes(to.path)) {
    //     next()
    // } else {
    //     next({
    //         path: '/e-403',
    //     })
    // }
    next()
}

router.beforeEach(async (to, from, next) => {
    if (to.matched.some(record => record.meta.requireLogin)) {
        if (!ls.get('token') && !ls.get("refresh_token")) {
            next({
                path: '/',
                query: {redirect: to.fullPath}
            })
        } else {
            if (store.state.menuListAll.length > 0) {
                checkAuthRouter(to, next)
            } else {
                const list = await getAction({url: sys_menu.leftMenuZTree});

                store.commit('setMenuData', list);
                checkAuthRouter(to, next)
            }
        }
    } else {
        next()
    }
});

router.afterEach((to)=>{
    if(window._hmt){
        window._hmt.push(['_trackPageview',to.fullPath])
    }
})

export default router
